import React from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
import { BookOpen } from 'lucide-react';
import { trackAddToCart } from '../hooks/useMetaPixel';
export function PricingSection() {
  const handleBuyClick = () => {
    trackAddToCart();
    window.location.href = 'https://recursosclaros.com/cart/43198680465505:1';
  };
  return <Section id="pricing" background="midnight" className="relative" data-id="element-130">
      <div className="max-w-4xl mx-auto bg-[#1e1b4b] rounded-2xl border border-[#d4a574]/30 overflow-hidden shadow-2xl shadow-black/50" data-id="element-131">
        <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-132">
          <div className="p-8 md:p-12 flex flex-col justify-center" data-id="element-133">
            <h2 className="text-3xl font-serif text-white mb-8" data-id="element-134">
              Qué incluye tu compra
            </h2>
            <ul className="space-y-6" data-id="element-135">
              <li className="flex items-start gap-4" data-id="element-136">
                <div className="text-[#d4a574] mt-1 flex-shrink-0" data-id="element-137">
                  <BookOpen size={20} data-id="element-138" />
                </div>
                <span className="text-slate-200 leading-snug" data-id="element-139">
                  Ebook completo: Reset de Ansiedad en 14 Noches
                </span>
              </li>
            </ul>
          </div>

          <div className="bg-[#0f172a] p-8 md:p-12 flex flex-col items-center justify-center text-center border-t md:border-t-0 md:border-l border-[#d4a574]/20" data-id="element-140">
            <div className="mb-2 text-slate-400 uppercase tracking-widest text-sm font-medium" data-id="element-141">
              Precio Único
            </div>
            <div className="flex items-baseline justify-center gap-3 mb-2" data-id="element-142">
              <span className="text-2xl font-serif text-slate-500 line-through" data-id="element-143">
                $29
              </span>
              <span className="text-6xl font-serif text-white" data-id="element-144">$6.36</span>
            </div>
            <div id="discount-badge" className="inline-block px-3 py-1 bg-[#d4a574]/20 rounded-full text-[#d4a574] text-sm font-medium mb-4" data-id="element-145">
              78% de descuento
            </div>
            <div className="text-[#d4a574] text-sm mb-8" data-id="element-146">
              Pago seguro • Descarga inmediata
            </div>

            <motion.button onClick={handleBuyClick} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="w-full inline-flex items-center justify-center px-8 py-4 text-lg font-medium transition-all duration-300 rounded-sm bg-[#d4a574] hover:bg-[#c9a86c] text-[#0f172a] shadow-[0_0_15px_rgba(212,165,116,0.3)] hover:shadow-[0_0_25px_rgba(212,165,116,0.5)] mb-4" data-id="element-147">
              Comprar Ahora
            </motion.button>

            <p className="text-xs text-slate-500 max-w-xs" data-id="element-148">
              Garantía de satisfacción. Si el protocolo no te ayuda en 14 días,
              te devolvemos tu dinero.
            </p>
          </div>
        </div>
      </div>
    </Section>;
}